import React, { useState } from 'react';
import TextareaAutosize from 'react-textarea-autosize';

export default function (props) {
	const [question, setQuestion] = useState('');
	const [visibility, setVisibility] = useState(false)
	function addAndClean(question) {
		if (question === '') {
			setVisibility(true);
		} else {
			props.addCustomQuestion(props.type, question)
			setQuestion('');
			setVisibility(false);
		}
	}
	return (
		<>
			<div className="add__custom">
				<TextareaAutosize
					placeholder="Add a question that we might have missed"
					onChange={(e) => setQuestion(e.target.value)}
					value={question}
					className='resize-none p-1 ml-3 w-[90%]'
				/>
				<div className="text__center btn btn__primary btn__rounded btn__md" onClick={() => addAndClean(question)}>
					<span className="material-icons font__30">
						add
					</span>
				</div>
			</div>
			{visibility &&
				<div>Please provide a value</div>
			}
		</>
	)
}